import shopifyGenericDefaults from '../shopify-generic/config.js';

shopifyGenericDefaults.Widgets.find((w) => w.name === 'RelatedItems').count = 4;

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
};
